
import genomeSidebar            from './genomeSidebar';
import React                    from 'react';
import ReactHelper              from '_utils/ReactHelper';
import SearchBarController      from '_controllers/SearchBarController';
import searchResultsTracker     from '../../shared/searchResultsTracker';
import VideoModalPoster         from '_views/shared/VideoModalPoster'

let genomePageElem, videoModalPoster;

const genomePage = {

  init() {
    /*
    ==================================================
     INIT SUB-MODULES
    ==================================================
    */

    genomeSidebar.init();
    searchResultsTracker.init();


    /*
    ==================================================
     CACHE DOM ELEMENTS
    ==================================================
    */
    
    const searchBar = document.querySelector('#main-search-bar-controller');

    genomePageElem = document.querySelector('.genome-page');
    videoModalPoster = document.querySelector('#video-modal-poster');


    /*
    ==================================================
     RENDER REACT COMPONENTS
    ==================================================
    */
    
    if (searchBar) {
      ReactHelper.renderComponent(<SearchBarController domain="genome"/>, '#main-search-bar-controller');
    }
    
    if (videoModalPoster) {
      ReactHelper.renderComponent(<VideoModalPoster />, '#video-modal-poster');
    }


    /*
    ==================================================
     WIRE DOM ELEMENTS
    ==================================================
    */
  },


  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */


  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

}

export default genomePage;
